
import React, { useState, useMemo, useCallback } from "react";
import Datetime from "react-datetime";
import "./button-group.scss";
import "./filter.scss";
import { connect } from "react-redux";
import { FilterAction } from "./redux/actions/FilterActions";
import { MessageAction } from "./redux/actions/MessageActions";
import { DataAction } from "./redux/actions/DataActions";
import { backendServer } from "./variables";
import ExportModal from "./ExportModal";

const mapStateToProps = (state) => ({ ...state });
const mapDispatchToProps = (dispatch) => ({
  addMessage: (message, type) => dispatch(MessageAction.addMessage(message, type)),
  setFromDate: (date) => dispatch(FilterAction.setFromDate(date)),
  setToDate: (date) => dispatch(FilterAction.setToDate(date)),
  toggleDetailedValues: () => dispatch(FilterAction.toggleDetailedValues()),
  toggleSensorFilter: (sensor) => () => {
    dispatch(FilterAction.toggleSensorFilter(sensor));
    dispatch(DataAction.updateChartData());
  },
  toggleFilters: () => dispatch(FilterAction.toggleFilters()),
  filterClick: (evt) => {
    if (evt.target.type === "radio") {
      if (evt.target.id === "option2") dispatch(FilterAction.selected24h());
      else if (evt.target.id === "option4") dispatch(FilterAction.selected1weed());
    }
  },
});

require("moment/locale/fi");

function Filters(props) {
  const [openExport, setOpenExport] = useState(false);
  const { filter, toDate, showDetailedValues, filterOpen, sensors } = props.filterState;
  const [localFromDate, setLocalFromDate] = useState(props.filterState.fromDate || "");

  const { data } = props.dataState;

  const anyHidden = useMemo(() => Object.values(sensors).some((v) => v === false), [sensors]);
  const filterClass = `date-selection ${filterOpen ? "open" : "closed"}`;

  const handleFromDateChange = (value) => {
    // Päivitetään aina paikallinen tila, oli se string tai Moment
    setLocalFromDate(value);

    // Jos arvo on Moment ja validi -> päivitetään Redux
    if (value && typeof value === "object" && value.toDate) {
      props.setFromDate(value);
    }
    // Jos arvo on string, ei vielä dispatchia
  };




  const sensorFilterList = useMemo(() => {
    return data
      .filter((item) => item && item.deviceid && !sensors[item.deviceid])
      .map((item, key) => (
        <label key={key + "frag"}>
          <input
            onChange={props.toggleSensorFilter(item.deviceid)}
            checked={sensors[item.deviceid]}
            type="checkbox"
          />
          {item.name || item.deviceid}
        </label>
      ));
  }, [data, sensors, props.toggleSensorFilter]);

  const openExportModal = useCallback(() => setOpenExport(true), []);
  const closeExportModal = useCallback((shouldExport) => () => {
    setOpenExport(false);
    if (shouldExport) exportAll();
  }, []);

  const exportAll = useCallback(async () => {
    const token = props?.loginState?.token;
    try {
      let res = await fetch(backendServer + "exportAll", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
          "x-api-key": "mIRmmtVxKs1JvsfZW8Bf74IWNqxiUCdl4KkFXrk1",
        },
      });
      if (res.status === 200) {
        props.addMessage("Tallennus käynnissä... Tarkista sähköpostisi.", "success");
      } else {
        props.addMessage("Tallennus epäonnistui. Ota yhteyttä ylläpitoon.", "warning");
      }
    } catch (e) {
      props.addMessage("Tallennus epäonnistui. Ota yhteyttä ylläpitoon.", "warning");
    }
  }, [props]);

  const radioOptions = [
    { id: "option2", label: "24h" },
    { id: "option4", label: "Viikko" },
  ];

  return (
    <>
      <ExportModal isOpen={openExport} onClose={closeExportModal} />
      <div className={filterClass}>
        <div className="content">
          <h3>Aikarajaus</h3>
          <div className="from">
            <label>Mistä</label>
                <Datetime
                  closeOnSelect={true}
                  className="dateinput"
                  value={localFromDate}
                  onChange={handleFromDateChange}
                />
          </div>
          <div className="to">
            <label>Mihin</label>
            <Datetime closeOnSelect={true} className="dateinput" value={toDate} onChange={props.setToDate} />
          </div>
          <div className="btn-group btn-group-toggle" data-toggle="buttons" onClick={props.filterClick}>
            {radioOptions.map(({ id, label }) => (
              <label
                key={id}
                className={filter === id ? "active button btn btn-secondary" : "button btn btn-secondary"}
              >
                <input type="radio" name="options" id={id} autoComplete="off" /> {label}
              </label>
            ))}
          </div>
          {anyHidden && (
            <>
              <h3>Näytä anturit</h3>
              {sensorFilterList}
            </>
          )}
          <h3>Lisätiedot</h3>
          <label>
            <input type="checkbox" value={showDetailedValues} onClick={props.toggleDetailedValues} />
            Näytä enemmän
          </label>
          <h3>Tallennus</h3>
          <button className="button button-secondary" onClick={openExportModal}>
            Vie kaikki tiedostoon
          </button>
        </div>
        <button className="visibility-btn" onClick={props.toggleFilters}>
          {filterOpen ? <span>&laquo;</span> : <span>&raquo;</span>}
        </button>
      </div>
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Filters);
